import React, { Component } from 'react';

import { DropdownMenuWrapper } from './DropdownMenu';

interface Item {
  shouldKeepDropdownOpen?: boolean;
  [key: string]: any;
}

interface DropdownStatefulProps {
  items?: Item[];
  renderMenu: (params: {
    items?: Item[];
    onChoose: (value: any, didConfirm: boolean, item: Item) => void;
    onClickOutside: () => void;
    style: React.CSSProperties;
  }) => React.ReactNode;
  renderToggle: (params: {
    onClick: (event: React.SyntheticEvent) => void;
  }) => React.ReactNode;
  onChoose?: (value: any, didConfirm: boolean, item: Item) => void;
  onOpen?: (event: React.SyntheticEvent) => void;
  onClose?: () => void;
  style?: React.CSSProperties;
}

interface DropdownStatefulState {
  isOpen: boolean;
}

class DropdownStateful extends Component<
  DropdownStatefulProps,
  DropdownStatefulState
> {
  static defaultProps = {
    style: {},
  };

  state: DropdownStatefulState = {
    isOpen: false,
  };

  close = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
    this.setState({ isOpen: false });
  };

  onChoose = (value: any, didConfirm: boolean, item: Item) => {
    if (didConfirm && !item.shouldKeepDropdownOpen) {
      this.close();
    }
    if (this.props.onChoose) {
      this.props.onChoose(value, didConfirm, item);
    }
  };

  onClickToggler = (event: React.SyntheticEvent) => {
    if (!this.state.isOpen && this.props.onOpen) {
      this.props.onOpen(event);
    }
    this.setState({ isOpen: !this.state.isOpen });
  };

  onClickOutside = () => {
    this.close();
  };

  render() {
    const { props } = this;

    const menu = !this.state.isOpen
      ? null
      : props.renderMenu({
          items: this.props.items,
          onChoose: this.onChoose,
          onClickOutside: this.onClickOutside,
          style: this.props.style || {},
        });
    const toggle = props.renderToggle({
      onClick: this.onClickToggler,
    });
    return (
      <DropdownMenuWrapper {...this.props}>
        {toggle}
        {menu}
      </DropdownMenuWrapper>
    );
  }
}

export default DropdownStateful;
